import { render, staticRenderFns } from "./TakePhotoMobile.vue?vue&type=template&id=b76c31f4&scoped=true&"
import script from "./TakePhotoMobile.vue?vue&type=script&lang=js&"
export * from "./TakePhotoMobile.vue?vue&type=script&lang=js&"
import style0 from "./TakePhotoMobile.vue?vue&type=style&index=0&id=b76c31f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76c31f4",
  null
  
)

export default component.exports